import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useCancelarAtividade = ({ dados }) => {
  const {
    request: cancelarRequest,
    data: cancelarData,
    errors: cancelarErrors,
    isLoading: cancelarIsLoading,
  } = useApiClient();

  const cancelarAtividade = () => {
    const parametros = {
      sequencialPedidoProrrogacao: dados?.sqPedidoProrrogacao,
      sequencialAndamento: dados?.sequencialUltimoAndamento,
      sequencialAtividade: dados?.sequencialUltimaAtividade,
    };

    cancelarRequest(apiRoutes.fiscalizacao.prorrogacaoos.cancelarAtividade, parametros);
  };

  useEffect(() => {
    if (cancelarIsLoading) return;

    if (!cancelarData && !cancelarErrors) return;

    if (cancelarData) {
      toast.success("Atividade cancelada com sucesso.");
      window.location.reload();
    }
  }, [cancelarData, cancelarErrors, cancelarIsLoading]);

  return { cancelarAtividade, cancelarErrors, cancelarIsLoading };
};

export default useCancelarAtividade;
